// import { useField } from "formik"
// import { useCallback } from "react";

// export const useAddRemoveMachines = () => {
//     const [{ value: machines }, , { setValue: setMachines, setError }] = useField<any>("machine_list");

//     const isAlreadyAdded = (machine: any) => {
//         console.log(machine);

//         return machine.id && machines.find((d: any) => d.id == machine.id)
//     }

//     const addMachines = useCallback((toAdd: any[]) => {

//         const addedMachines = toAdd
//             .filter((d) => !isAlreadyAdded(d))
//             .map((machine) => {

//                 const { id, name } = machine;

//                 return {
//                     id: id,
//                     name: name
//                 }
//             })
//         setMachines([...(machines ?? []), ...addedMachines]);

//         return addedMachines;
//     }, [machines, setMachines])

//     const removeMachines = useCallback((toRemove: { id: string }[]) => {
//         const idsToRemove = toRemove.map((d) => d.id);

//         setMachines(machines.filter((m: any) => !idsToRemove.includes(m.id!)));
//         setError(undefined);
//     }, [machines, setMachines, setError])

//     return {
//         machines,
//         isAlreadyAdded,
//         removeMachines,
//         addMachines
//     }
// }

import { useField } from "formik";
import { useCallback } from "react";
export const useAddRemoveMachines = () => {
    const [{ value: machines }, , { setValue }] = useField<any[]>("machine_list");

    const addMachines = useCallback((toAdd: any[]) => {
        const existing = machines || [];

        const newOnes = toAdd.filter(
            (m) => !existing.some((e) => e.id === m.id)
        );

        setValue([...existing, ...newOnes]);
    }, [machines, setValue]);

    const removeMachines = useCallback((ids: string[]) => {
        setValue((machines || []).filter((m) => !ids.includes(m.id)));
    }, [machines, setValue]);

    const removeByPlatformIds = useCallback((platformIds: string[]) => {
        setValue(
            (machines || []).filter((m) => !platformIds.includes(m.platform_id))
        );
    }, [machines, setValue]);

    return {
        machines: machines || [],
        addMachines,
        removeMachines,
        removeByPlatformIds
    };
};